/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE INDICATOR : STYLES --------------- ++++++++++ */
export default theme => ({
	imageindicator: {
		// cursor: 'pointer',
		// display: 'block',
		// extend: [imageTypes.icon],
		// width: pxToEm(20),
		// height: pxToEm(20),
		zIndex: '9',
		opacity: '1',
		transition: 'opacity .2s linear 0s',

		background: `rgba(255, 255, 255, 0.3)`,
		padding: replacePXinStringWithEM(`5px 10px`),
		borderRadius: pxToEm(6)
		// filter: replacePXinStringWithEM(`drop-shadow(0px 0px 2px #222)`),
		// '&.white': {
		// 	backgroundImage: `url(${url.image}/mks/icon-photo-white.png)`,
		// },
		// '&.blue': {
		// 	backgroundImage: `url(${url.image}/mks/icon-photo-blue.png)`,
		// }
	}
});
